export type ActionTone = 'brand' | 'neutral' | 'danger';

const actionTones: Record<ActionTone, string> = {
  brand: 'bg-red-50 text-primary hover:bg-red-100',
  neutral: 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50',
  danger: 'text-gray-600 hover:bg-red-50 hover:text-red-700',
};

type ActionButtonProps = {
  label: string;
  icon: React.ReactNode;
  tone: ActionTone;
  onClick: () => void;
  disabled?: boolean;
  // Número que se muestra como insignia junto a la etiqueta (p. ej. miembros).
  badge?: number;
};

const ActionButton = ({
  label,
  icon,
  tone,
  onClick,
  disabled = false,
  badge,
}: ActionButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`inline-flex h-8 items-center gap-1.5 rounded-md px-3 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed ${actionTones[tone]}`}
  >
    {icon}
    {label}
    {badge !== undefined && (
      <span className="rounded-full bg-white px-1.5 text-xs font-semibold text-primary">
        {badge}
      </span>
    )}
  </button>
);

export default ActionButton;
